import React, {Suspense} from 'react';
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import PageLayout from "@view/layout/pageLayout/PageLayout";
import {AutoTrackingGroupsLazy} from "@containers/map/containers/autoTrackingGroups/AutoTrackingGroups.lazy";


const AutoTrackingGroupsPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <AutoTrackingGroupsLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default AutoTrackingGroupsPage;